interface SEOProps {
    title: string;
    description?: string;
}

export function SEO({ title, description }: SEOProps) {
    document.title = title;

    if (description) {
        let metaDescription = document.querySelector(
            'meta[name="description"]'
        ) as HTMLMetaElement | null;

        if (!metaDescription) {
            metaDescription = document.createElement('meta');
            metaDescription.name = 'description';
            document.head.appendChild(metaDescription);
        }

        metaDescription.content = description;
    }

    return null;
}